<template>
  <div id="app">
    <img class="banner" src="./assets/banner.jpg" />
    <div class="header">
      <div class="v_title">武汉卓益通信息技术有限公司</div>
      <span class="v_select" :class="currIndex === 0 ? 'bg_yellow' : 'bg_aliceblue'" @click="onClick(0)">首页</span>
      <span style="color: #ffffff">|</span>
      <span class="v_select" :class="currIndex === 1 ? 'bg_yellow' : 'bg_aliceblue'" @click="onClick(1)">产品</span>
      <span style="color: #ffffff">|</span>
      <span class="v_select" :class="currIndex === 2 ? 'bg_yellow' : 'bg_aliceblue'" @click="onClick(2)">关于我们</span>
    </div>
    <div class="v_content" v-if="currIndex == 0">
      <div style="flex-direction: column; margin-left: 15%">
        <div style="font-size: 35px">简介</div>
        <div style="font-size: 25px">Introduce</div>
        <p style="font-size: 15px; margin-top: 15px; line-height: 25px">
          本公司专注于日常工具、旅游、漫画、百科、购物等产品的开发与运营，依托阅读领域多年积累的经验，自主开发了多款 APP 及快应用产品，涵盖：亿安扫描、千宝易购、锦程金选、漫界星图（漫画）、厨谱集、 乐购优选、智识库等，同时与国内外多家知名版权公司达成合作，经过持续探索与完善，在产品、技术、内容、运营、推广等方面已形成独特的风格与模式，公司现拥有经验丰富的产品运营团队与强大的技术开发队伍，未来将持续深耕数字阅读平台运营、内容制作发行、产品开发、IP孵化、阅读改编及测评相关等领域，不断推动业务创新与发展。
        </p>
      </div>
      <img style="margin-right: 25%; margin-left: 15%; width: 200px; height: 230px" src="./assets/bg01.jpg" alt="" />
    </div>
    <img v-if="currIndex == 1" src="./assets/tinified/1.jpg" style="height: auto; width: 100%;" alt="">
    <!-- <img v-if="currIndex == 1" src="./assets/tinified/2.jpg" style="height: auto; width: 100%;" alt="">
    <img v-if="currIndex == 1" src="./assets/tinified/3.jpg" style="height: auto; width: 100%;" alt=""> -->
    <div class="v_content_About" v-if="currIndex == 2">
      <div style="flex-direction: column">
        <div style="font-size: 35px; margin-top: 30px">关于我们</div>
        <div style="font-size: 25px">About us</div>
        <div class="v_text">
          公司在日常工具，小说阅读，购物等领域经过多年发展，现已在技术、产品、运营、内容领域积累丰富的经验，利用自己强大的产品开发能力和丰富的内容分发渠道，与内容版权公司合作，将优秀的作品快速投入市场，并取得不错的效果。并且公司拥有自己的产品开发团队和运营团队，未来将在小说IP孵化、游戏影视剧改编、小说周边等多领域发展。
        </div>
        <div class="v_text">
          公司深耕工具领域多年，在技术研发、产品打造、运营管理、内容建设等方面积累了丰厚经验，拥有专业的产品开发、版权运营及涵盖技术、内容、设计、推广等领域的资深团队，依托强大的产品开发能力与成熟的内容分发渠道，既自主进行内容设计创作，也与国内外众多小说公司、漫画作者深度合作，通过精准的内容包装定位与高效渠道推广，实现优质作品快速市场化，达成互利共赢的合作成果；同时，公司积极探索趣味测评等多元业务领域，未来将重点发力小说IP 孵化、游戏与影视剧改编、小说周边开发等方向，借助短视频、图文、有声、直播等新媒体形式培育IP，打造涵盖小说图文、有声内容、影视游戏、周边衍生、广告及教育等板块的完整产业链，持续拓展产品领域业务，实现协同创新与长远发展。 IP 孵化、游戏与影视剧改编、小说周边开发等方向，借助短视频、图文、有声、直播等新媒体形式培育 IP，打造涵盖小说图文、有声内容、影视游戏、周边衍生、广告及教育等板块的完整产业链，持续拓展小说领域业务，实现协同创新与长远发展。
        </div>
      </div>
    </div>
    <div class="footr">
      <div>
        <p style="font-size: 15px">
          CopyRight © 2024 - 2026 武汉卓益通信息技术有限公司
          版权所有备案编号：<a href="https://beian.miit.gov.cn/" target="_blank">鄂ICP备2023024434号-1</a>
        </p>
        <p style="font-size: 15px">
          网络文化经营许可证编号：鄂网文（2025）0958-211号
        </p>
        <p style="font-size: 15px">
          公司地址：湖北省武汉市汉阳区四新北路111号绿地·国博广场2号楼6层办公14号-1
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currIndex: 0,
    };
  },
  methods: {
    onClick(i) {
      this.currIndex = i;
    },
  },
};
</script>

<style>
#app {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.banner {
  width: 100%;
  height: 580px;
}

.header {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 15%;
  width: 100%;
}

.v_title {
  font-size: 30px;
  color: aliceblue;
  font-weight: 600;
  margin-right: 100px;
}

.v_select {
  cursor: pointer;
  margin: 0% 5%;
  font-size: 15px;
  font-weight: 700;
}

.bg_yellow {
  color: yellow;
}

.bg_aliceblue {
  color: aliceblue;
}

.v_content {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  margin-bottom: 10px;
}

.swper_view {
  display: flex;
  flex-direction: row;
}

.v_prodect {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.pro_img_view {
  display: flex;
  flex: 1;
  justify-content: space-around;
  height: 450px;
  margin-top: 30px;
  margin-bottom: 30px;
}

.v_content_About {
  flex-direction: column;
  margin-left: 15%;
  margin-right: 15%;
  margin-bottom: 10px;
}

.footr {
  display: flex;
  justify-content: center;
  align-items: center;
  background: darkgray;
  height: 100px;
}

.index_view {
  display: flex;
  flex-direction: row;
  margin-top: 50px;
}

.v_text {
  font-size: 15px;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
